import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manutencoes',
  templateUrl: './manutencoes.component.html',
  styleUrls: ['./manutencoes.component.scss']
})
export class ManutencoesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
